import axios from 'axios';
import qs from "qs";

const apiKey = "keyaN2Tg6ZQmP0u1t";
const baseDomain = "https://api.airtable.com/v0";
const baseURL = `${baseDomain}/appj5dUHuKMVFqVT8`; // READ-ONLY
// const  VUE_APP_AIRTABLE_CONTACT_BASE = "appVZpBZMEB67XrPr"; // WRITE-ONLY

export default axios.create({
    baseURL,
    headers: {
        "Authorization": `Bearer ${apiKey}`
    },
    paramsSerializer: function (params) {
        return qs.stringify(params, { arrayFormat: 'brackets' });
    },
});